import Vue from 'vue';

Vue.mixin({
  methods: {
    async handleCustomerAlbum(album) {
      const albumId = album.is_private
          ? `${album.hash}-${album.hash_password}`
          : album.id;

      const tagHash = this.$route.params.tag;

      let customerItem;

      if (tagHash && tagHash.split('-').length > 0) {
        customerItem = this._.find(this.customerItems, {
          hash: albumId,
          tag_url: tagHash,
        });
      } else {
        customerItem = this._.find(this.customerItems, {
          hash: albumId,
        });
      }

      if (!customerItem && album && album.album_items && album.album_items.length > 0) {
        const albumItems = album.album_items.filter(item => !+item.is_group);
        const data = {
          first_photo: album.first_photo,
          hash: albumId,
          primary_photo: this._.first(albumItems),
          title: album.title,
        };

        if (tagHash) {
            data.tag_url = tagHash;
            data.total_pictures = 0;

          const response = await this.axios.get(`/v2/albums/${albumId}/items?tag=${tagHash}`);

          if (response && response.data.success) {
            data.total_pictures = response.data.data.length;
          }
        } else {
          data.total_pictures = album.total_pictures;
        }

        if (!tagHash || tagHash && tagHash.split('-').length > 1) {
          this.$store.dispatch('ADD_CUSTOMER_ITEM', data);
        }
      }
    },
  },
});

